import { useState } from "react";
import { CalendarCheck, DeviceMobile, Gift, BookOpen, Sparkle, Truck } from "@phosphor-icons/react";
import { btnPrimary, ReadOnlyNote } from "./shared";

const SERVICES = [
  ["prenotazioni", "Prenotazioni", "Prenotazioni tavoli online e da pannello.", CalendarCheck],
  ["delivery", "Delivery", "Consegna a domicilio dei piatti.", Truck],
  ["self_order", "Self Order", "Ordinazione autonoma dal tavolo con QR.", DeviceMobile],
  ["gift_card", "Gift Card", "Vendita e gestione buoni regalo.", Gift],
  ["esperienze", "Esperienze", "Degustazioni, eventi e pacchetti speciali.", Sparkle],
  ["menu", "Menu", "Menu digitale consultabile dai clienti.", BookOpen],
];

function Toggle({ checked, onChange, testid, label }) {
  return (
    <button type="button" onClick={() => onChange(!checked)} data-testid={testid}
      className={`relative w-11 h-6 rounded-full transition-colors ${checked ? "bg-emerald-500" : "bg-zinc-300"}`}
      aria-label={label}>
      <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform ${checked ? "translate-x-[22px]" : "translate-x-0.5"}`} />
    </button>
  );
}

export default function ServiziSection({ settings, onSave, saving, readOnly }) {
  const [s, setS] = useState(settings.servizi || {});
  const setSvc = (k, patch) => setS({ ...s, [k]: { ...(s[k] || {}), ...patch } });

  return (
    <div className="space-y-5" data-testid="setsection-servizi">
      <div className="grid sm:grid-cols-2 gap-3">
        {SERVICES.map(([key, label, desc, Icon]) => (
          <div key={key} className="bg-white border border-zinc-200 rounded-lg p-4" data-testid={`srv-${key}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 rounded-lg bg-zinc-100 text-zinc-600 flex items-center justify-center">
                  <Icon size={18} weight="bold" />
                </span>
                <div>
                  <div className="text-sm font-bold text-zinc-900">{label}</div>
                  <div className="text-xs text-zinc-500">{desc}</div>
                </div>
              </div>
              <Toggle checked={!!s[key]?.attivo} onChange={(v) => setSvc(key, { attivo: v })}
                testid={`srv-${key}-attivo`} label={`Attiva ${label}`} />
            </div>
            {s[key]?.attivo && (
              <label className="flex items-center gap-2 mt-3 pt-3 border-t border-zinc-100 text-xs text-zinc-600">
                <input type="checkbox" checked={!!s[key]?.prenotabile}
                  onChange={(e) => setSvc(key, { prenotabile: e.target.checked })}
                  data-testid={`srv-${key}-prenotabile`} className="w-4 h-4 accent-zinc-900" />
                Prenotabile online dai clienti
              </label>
            )}
          </div>
        ))}
      </div>
      <p className="text-xs text-zinc-500">Gli orari di disponibilità dei servizi si configurano in <b>Orari e turni</b>.</p>
      {readOnly ? <ReadOnlyNote /> : (
        <button disabled={saving} onClick={() => onSave({ servizi: s })} className={btnPrimary} data-testid="srv-save">
          Salva Servizi
        </button>
      )}
    </div>
  );
}
